import { render, staticRenderFns } from "./leaderboard-table.vue?vue&type=template&id=480a9599&scoped=true&"
import script from "./leaderboard-table.vue?vue&type=script&lang=js&"
export * from "./leaderboard-table.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-table.vue?vue&type=style&index=0&id=480a9599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a9599",
  null
  
)

export default component.exports